
/*

THIS IS MY FIRST VUE COMP. IN TYPESCRIPT, SO PROBABLY NOT EVERYTHING PERFECT

*/

// @ts-nocheck looool

import Vue from "vue";

import {
  SurveySetup,
  Openq as OpenqView,
  Testimonial as TestimonialView,
  Multiq as MultiqView,
  Singleq as SingleqView,
  Welcome as WelcomeView,
  ThankYou as ThankYouView,
  Shareq as ShareqView,
  Contactq as ContactqView,
  Referralq as ReferralqView,
  Ratingq as RatingqView,
} from "../../../../../Overarching Resources/TS/Survey/types";
import Savebutton from "../components/ptcomponents/Savebutton.vue";
import debounce from 'debounce'
import Welcome from "./components/Welcome.vue";
import RatingQ from "./components/RatingQ.vue";
import Testimonial from "./components/Testimonial.vue";
import OpenQ from "./components/OpenQ.vue";
import SelectQ from "./components/SelectQ.vue";
import ShareQ from "./components/ShareQ.vue";
import ContactQ from "./components/ContactQ.vue";
import Referralq from "./components/Referralq.vue";
import ThankYou from "./components/ThankYou.vue";
import AddComponent from "./components/common/AddComponent.vue";
import { decode } from "../../../../../Overarching Resources/TS/Survey/surveyHelperMethods";
import { createStep } from "fblshared";
import Pagesubtitle from "../components/ptcomponents/Pagesubtitle.vue";

type SurveyViewStep =
  | OpenqView
  | RatingqView
  | TestimonialView
  | MultiqView
  | SingleqView
  | WelcomeView
  | ThankYouView
  | ShareqView
  | ContactqView
  | ReferralqView
  | { type: "AddComponent" };

export default Vue.extend({
  data() {
    return {
      surveySetup: <{} | SurveySetup>{},
      removeStepConfirm: false,
      initialLoadString: "",     
      iframeLoading: false,
      stepComponentMap: {
        ratingq: "RatingQ",
        openq: "OpenQ",
        testimonial: "Testimonial",
        multiq: "SelectQ",
        singleq: "SelectQ",
        welcome: "Welcome",
        thankyou: "ThankYou",
        shareq: "ShareQ",
        contactq: "ContactQ",
        referralq: "Referralq",
        AddComponent: "AddComponent",
      },
    };
  },
  watch: {
    '$store.state.survey.currentFocusIndex'(v) {
      if (v !== false && !this.$store.state.survey.currentFocusIndexHasErrors) {
          this.renderNewPreview(v, false) 
      }
    },
    currentSurveyFlow: {      
      handler: debounce(function() {
        const focusIndex = this.$store.state.survey.currentFocusIndex
        if (!this.$store.state.survey.currentFocusIndexHasErrors && focusIndex !== false) {
          this.renderNewPreview(focusIndex, false)
        }
      }, 700),
      deep: true
    }
  },
  computed: {
    inviteOnly: {
      get() {
        return this.$store.state.survey.surveySetup.inviteOnly
      },
      set(v) {
        this.$store.commit('survey/UPDATE_INVITE_ONLY', v)
      }
    },
    windowWidth () { return this.$store.state.windowWidth },
    allowAddRating(): boolean {     
      let hasRating = false 
      for (const step of this.currentSurveyFlow) {
        if (step.type === 'ratingq') {
          hasRating = true
          break
        }
      }
      return !hasRating
    },
    currentFlowString(): string {
      return this.flattenOrderStringifyObject(
        {
          flow: this.currentSurveyFlow,
          inviteOnly: this.inviteOnly
        }
        );
    },
    showSaveBtn(): boolean {
      return this.initialLoadString !== this.currentFlowString;
    },
    formReady(): boolean {
      return true;
    },
    removeStepConfirmBool(): boolean {
      return Boolean(this.removeStepConfirm);
    },
    currentSurveyFlow: {
      //the actual full flow as in store
      get: function (): SurveyViewStep[] {
        return this.$store.state.survey.surveyFlow as SurveyViewStep[];
      },
      set: function (v: SurveyViewStep[]): void {
        this.$store.commit("survey/CHANGE_FLOW", v);
      },
    }
  },
  mounted() {
    document.addEventListener('scroll', this.updatePreviewScroll)
    this.renderNewPreview(0, false)
  },
  destroyed() {
    document.removeEventListener('scroll', this.updatePreviewScroll)
  },
  created() {
    this.init();
  },
  methods: {
    scrollToActive() {
      const el = document.getElementsByClassName('fbl_stepcomp opencomp')[0]
      el.scrollIntoView({behavior: 'smooth'})
    },
    compRequestPreview(i) {
      //a child component has requested to be previewed
      this.renderNewPreview(i, false)
    },
    updatePreviewScroll: debounce(function() {
    const previewEl = this.$refs.preview
    const previewWrap = this.$refs.previewwrap
      if (this.windowWidth > 992) {        

        const offset = window.pageYOffset + previewWrap.getBoundingClientRect().top
        const scrollY = window.scrollY
        if (scrollY < (offset - 60))  {
          previewEl.style.transform = `translateY(${scrollY}px)`
        } else {
          previewEl.style.transform = `translateY(${scrollY - 100}px)`
        }

      } else {
        previewEl.style.transform = 'none'
      }      
    }, 20),
    renderNewPreview(index, full = false) {      

      //don't refresh if we're navigated away      
      if (this.$route.name !== 'survey-flow') return
    
       //post into iframe to get survey preview
      const form = document.createElement('form')
      form.method = 'post';
  
      // @ts-ignore
      if (process.env.NODE_ENV === 'development') {
        form.action = 'http://localhost:1088/mysurveypreview';
      } else {
        const isAgencyClient = this.$store.getters['dash/isAgencyClientCollaborator']
        form.action = `https://${isAgencyClient ? 'givefdbck.com' : 'feedback.link'}/mysurveypreview`;
      }

      if (full) {
        form.target = '_blank'
      } else {
        form.target = 'previewframedash'
      }      

      //if we need full preview,  get ratingtype
      let ratingType = this.$store.state.survey.surveySetup.ratingType         

      const postData = {
        isAgencyClient: this.$store.getters['dash/isAgencyClientCollaborator'],
        videoEnabled: this.$store.state.dash.viewData.business.surveySetup.videoEnabled,
        previewType: full ? 'full' : 'onestep',
        appearanceInfo: {
            showWhiteLogoBackground: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBackground,
            showWhiteLogoBorder: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBorder,
            secondaryHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
            backgroundHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex,
            logoUrl: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl            
        },
        fbaHandle: this.$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle,
        platformData: this.$store.state.dash.viewData.business.externalPlatforms,
        businessInfo: this.$store.state.dash.viewData.business.businessInfo,
        language: this.$store.getters['dash/currentLanguagePackName'],
        languagePack: this.$store.getters['dash/currentLanguagePack'],
        stepData: index !== false ? this.currentSurveyFlow[index] : false,
        surveyFlow: full ? [...this.currentSurveyFlow] : false,
        ratingType: ratingType
      }

      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'json'
      hiddenField.value = JSON.stringify(postData)
      form.appendChild(hiddenField)

      document.body.appendChild(form)
    
      this.iframeLoading = true
            
      form.submit()       

      setTimeout(() => {
        form.remove()
      }, 500)

    },
    flattenObject(ob): any {
      var toReturn = {};
      for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if (typeof ob[i] == "object") {
          var flatObject = this.flattenObject(ob[i]);
          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue;

            toReturn[i + "." + x] = flatObject[x];
          }
        } else {
          toReturn[i] = ob[i];
        }
      }      
      return toReturn;
    },
    flattenOrderStringifyObject(ob): string {      
      const flat = this.flattenObject(ob)
      const stringed = JSON.stringify(flat, Object.keys(flat).sort());
      return stringed;
    },
    update(): void {

        this.$vs.loading()
        this.$store.dispatch('survey/UPDATE_SURVEY_FLOW').then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Updated survey flow',
            text: 'Survey flow updated!',
            color: 'success',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-check'})
            
            //give business doc time to sync
            this.init(true)            

        }).catch((e) => {
          //noconsoleconsole.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Survey flow',
            text:'Oops! Something went wrong, and we couldn\'t update your survey flow. Please try again, and reach out for support if it happens again.',
            color: 'warning',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        })
    },
    addComponent(type, index): void {
      const currentFlow = [...this.currentSurveyFlow];
      const newStep = createStep(
        type,
        this.$store.getters["dash/currentLanguagePackName"].substring(0, 2),
        this.$store.state.survey.surveySetup.ratingType
      );

      //calculate what survey rating type should be
      if (type === 'ratingq') this.$store.commit('survey/COMPUTE_RATING_TYPE')

      currentFlow.splice(!index.above ? index.i + 1 : index.i, 0, newStep);

      this.$store.commit('survey/CHANGE_FOCUS_INDEX', !index.above ? index.i + 1 : index.i)      

      this.currentSurveyFlow = currentFlow;

      this.$store.commit("survey/HIGHLIGHT_STEP", newStep.uniqueID);

      

    },
    moveUp(compI): void {
      const flowCopy = [...this.currentSurveyFlow];
      flowCopy.splice(compI - 1, 0, flowCopy.splice(compI, 1)[0]);
      this.currentSurveyFlow = flowCopy;
      this.$store.commit("survey/HIGHLIGHT_STEP", flowCopy[compI - 1].uniqueID);  

      //reset new question open flag
      this.Zuestion = false

    },
    moveDown(compI): void {
      const flowCopy = [...this.currentSurveyFlow];
      flowCopy.splice(compI + 1, 0, flowCopy.splice(compI, 1)[0]);
      this.currentSurveyFlow = flowCopy;
      this.$store.commit("survey/HIGHLIGHT_STEP", flowCopy[compI + 1].uniqueID);      

      //reset new question open flag
      this.newlyAddedQuestionI = false

    },
    acceptRemove(compI): void {
      const flowCopy = [...this.currentSurveyFlow]; 
      const removeCompType = flowCopy[compI].type     
      flowCopy.splice(compI, 1);      

      this.currentSurveyFlow = flowCopy;      

      //calculate what survey rating type should be if needed
      if (removeCompType === 'ratingq') this.$store.commit('survey/COMPUTE_RATING_TYPE')

      this.$store.commit('survey/CHANGE_FOCUS_INDEX', false)

      //reset new question open flag
      this.newlyAddedQuestionI = false

    },
    removePrompt(compI): void {
      const toRemove = this.$store.state.survey.surveyFlow[compI];
      let message;
      let question = false;
      if (toRemove.type !== "welcome") {
        let ask = toRemove.content.ask;
        let decoded = decode(ask as string);

        if (decoded) {
          //official language field
          ask = this.$store.getters["dash/specificLanguagePack"](
            decoded.languagePackSlug
          )[decoded.slug].replaceAll(
            "[businessname]",
            this.$store.state.dash.viewData.business.businessInfo.businessName
          );
        }
        question = ask ? ask.substring(0, 40) : "";
      }

      this.removeStepConfirm = {
        question,
        compI,
        remove: this.acceptRemove.bind(this, compI),
      };
    },
    init(wasUpdate = false): void {      
      //populate flow and setup into vuex state ONLY if we're loading a new entity (either page reload or location switch)               
      
      if (wasUpdate) {
        this.initialLoadString = this.flattenOrderStringifyObject(
          {
            flow: this.$store.state.survey.surveyFlow,
            inviteOnly: this.inviteOnly
          }
        ); 
      } else {
        if (this.$store.state.survey.surveyFlow.length === 0) {
          this.$store.commit(
          "survey/SYNC_FLOW",
          this.$store.state.dash.viewData.business.surveySetup
        );
        this.initialLoadString = this.flattenOrderStringifyObject(
          {
            flow: this.$store.state.dash.viewData.business.surveySetup.surveyFlow,
            inviteOnly: this.inviteOnly
          }
        ); 
      }    
      }      

    },
  },
  components: {
    OpenQ,
    Testimonial,
    ThankYou,
    RatingQ,
    SelectQ,
    ContactQ,
    Referralq,
    Welcome,
    ShareQ,
    Pagesubtitle,
    AddComponent,
    Savebutton,
  },
});

/*

The goal of this component is to be exceptionally compliant and presentable as a TS <>  Vue explainer.
        
            1. Pull a local list of questions from the state
            2. Add the required local view vars - inject(questionType)
            ...
            x. Before it's sent to DB, clean it - clean()        



Vue design:

    What's going to be the pattern here?

    - Every step comp. takes different props
    - Every step comp. emits different actions
    - Every step comp. needs to change the state of that comp's data


    Will components be dumb and just serve as views that pass data and events up?
    Will components be smart and change data themselves through Vuex?

    Combination of both:
        COMPONENTS will call a change field method, with the component index, and fieldId === step fieldId
            - On render, if a field value is translation, it will pull in the corresponding translated string
            - If field changes to false, component will pull in the translation, and put it in the placeholder
            - Uploads of images/videos
            - Validation

    
    Welcome
        changeValue(compIndex, newValue)

    MUTATIONS
    EVENTS
        changeStringValue
        

*/
